/**
 * Rectangle.js
 * Created on 10-okt-2013
 * 
 * 
 * @author Reinier Feijen for Ranj
 **/


export default class Rectangle {
    constructor(x, y, width, height) {
        this.x = x || 0;
        this.y = y || 0;
        this.width = width || 0;
        this.height = height || 0;
    }

    /**
     * Returns a clone of the Rectangle instance.
     * @method clone
     * @return {Rectangle} a clone of the Rectangle instance.
     **/
    clone() {
        return new Rectangle(this.x, this.y, this.width, this.height);
    }

    /**
     * Returns a string representation of this object.
     * @method toString
     * @return {String} a string representation of the instance.
     **/
    toString() {
        return `[Rectangle (x=${this.x} y=${this.y} width=${this.width} height=${this.height})]`;
    }
}
